/**
 * Erros da app web, da extensão e da app de Mac enviados à API (POST /public/client-errors), para sabermos
 * quando algo falha a quem usa. Sem dados pessoais: só a mensagem e a pilha, limpas de
 * emails, números longos, endereços com parâmetros e tokens, e cortadas.
 */
export interface ClientErrorReport {
  source: 'web' | 'extension' | 'mac';
  /** Versão da app web (build), da extensão ou da app de Mac. */
  version: string;
  /** Onde: o caminho da página (sem parâmetros) ou a parte da extensão (sw, sidepanel…). */
  where: string;
  message: string;
  stack?: string;
}

export const CLIENT_ERROR_LIMITS = { message: 300, stack: 2000, where: 120, version: 40 };

/** Tira da mensagem o que pode identificar alguém ou dar acesso. */
export function scrubErrorText(text: string, max: number): string {
  return text
    .replace(/[\w.+-]+@[\w-]+(\.[\w-]+)+/g, '<email>')
    .replace(/\b(eyJ[\w-]+\.[\w-]+\.[\w-]+)\b/g, '<token>')
    .replace(/(https?:\/\/[^\s?#'")]+)[?#][^\s'")]*/g, '$1')
    .replace(/\b[A-Za-z0-9_-]{32,}\b/g, '<id>')
    .replace(/\d{6,}/g, '<n>')
    .slice(0, max);
}

/** Caminho de uma página sem parâmetros, com ids e tokens trocados por marcas. */
export function scrubPath(path: string): string {
  return scrubErrorText(
    path
      .split(/[?#]/)[0]!
      .replace(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, ':id'),
    CLIENT_ERROR_LIMITS.where,
  );
}

export function cleanReport(r: ClientErrorReport): ClientErrorReport {
  const L = CLIENT_ERROR_LIMITS;
  return {
    source: r.source === 'extension' || r.source === 'mac' ? r.source : 'web',
    version: String(r.version ?? '').slice(0, L.version),
    where: scrubPath(String(r.where ?? '')),
    message: scrubErrorText(String(r.message ?? ''), L.message),
    ...(r.stack ? { stack: scrubErrorText(String(r.stack), L.stack) } : {}),
  };
}
